import { Component } from '@angular/core';

@Component({
  selector: 'iris-card-footer',
  host: { class: 'iris-card-footer' },
  template: `<ng-content></ng-content>`,
  standalone: false
})

export class IrisCardFooterComponent {}
